// @ts-nocheck
/**
 * AgOrderGrid — Order By SKU grid wrapper
 *
 * Thin wrapper around BaseOrderGrid with SKU-page-specific configuration:
 * multi-row selection, availability capping, auto-discovery columns, metrics column groups.
 */
import React from 'react';
import BaseOrderGrid, { MetricConfig } from './baseOrderGrid';
import { METRICS_COLUMN_GROUPS } from '../metricsColumnConfig';
import { COL_CONFIG, EXCLUDED_GRID_FIELDS, GROUP_OPTIONS, ORDER_SKUS_TABLE_ID } from '../constants';

interface Props {
	data: Record<string, any>[];
	onOrderQtyChange?: (rowIdx: number, storeId: string, newQty: number) => void;
	onSelectionChanged?: (selectedRows: Record<string, any>[]) => void;
	groupableColumns?: { key: string; label: string }[];
	skuAvailQty?: number;
	shelfQtyField?: string;
	skuLabel?: string;
	skuDesc?: string;
	skuOrdTotal?: number;
	skuRemain?: number;
	gridApiRef?: React.MutableRefObject<any>;
}

const SKU_METRICS_CONFIG: MetricConfig[] = [
	{ label: 'STORES', valueFn: (d) => new Set(d.map((r) => r.Store).filter(Boolean)).size, color: '#1565c0' },
	{ label: 'WAREHOUSES', valueFn: (d) => new Set(d.map((r) => r.Warehouse).filter(Boolean)).size, color: '#6a1b9a' },
];

const AgOrderGrid: React.FC<Props> = ({
	data,
	onOrderQtyChange,
	onSelectionChanged,
	groupableColumns,
	skuAvailQty,
	shelfQtyField,
	skuLabel,
	skuDesc,
	skuOrdTotal,
	skuRemain,
	gridApiRef,
}) => {
	return (
		<BaseOrderGrid
			data={data}
			colConfig={COL_CONFIG}
			groupOptions={GROUP_OPTIONS}
			excludedFields={EXCLUDED_GRID_FIELDS}
			metricsColumnGroups={METRICS_COLUMN_GROUPS}
			onOrderQtyChange={onOrderQtyChange}
			entityIdField="Store"
			shelfQtyField={shelfQtyField}
			availabilityQty={skuAvailQty}
			selectionMode="multiRow"
			onSelectionChanged={onSelectionChanged}
			metricsConfig={SKU_METRICS_CONFIG}
			groupableColumns={groupableColumns}
			gridApiRef={gridApiRef}
			tableId={ORDER_SKUS_TABLE_ID}
		/>
	);
};

export default AgOrderGrid;
